<template>
    <v-checkbox
        class="body-2 mt-0 mb-6"
        :input-value="setValue"
        :name="metadata.name"
        hide-details
        :rules="[
            !required || requiredField()
        ]"
        :data-meta-id="metadata.id"
        :id="metadata.name"
        @change="emitValue"
    >
        <div slot="label">
            <span v-html="(required ? '* ' : '') + $t('form.covid195To11ConfirmReadDocument.label')" />
        </div>
    </v-checkbox>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'covid511-confirm-read-document',
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        setValue() {
            return this.value ? 1 : 0;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
